'use strict';

var GridContributingFBCsFilterFactory = function GridContributingFBCsFilterFactory(DemandFilter, angularHelper, featureToggleService) {
  var filtersNamesList = ['FBCsFilterByClassFactory', 'FBCsFilterByFBGFactory'];
  if (featureToggleService.isEnabled('SPOS')) {
    filtersNamesList.push('FilterBySposFactory');
  }
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function GridContributingFBCsFilter() {
    DemandFilter.call(this, 'fares-mode', 'contributing-fbcs');
    this.registerFilters(injectedFilters);
  }
  GridContributingFBCsFilter.prototype = Object.create(DemandFilter.prototype);
  GridContributingFBCsFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return GridContributingFBCsFilter;
};
GridContributingFBCsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper', 'FeatureToggleService'];
module.exports = GridContributingFBCsFilterFactory;